// Sometimes we want paths to be accessible to both signed in and not signed in users.
export const sharedPaths = ["/documents", "forms"];
